import React, { useMemo } from 'react'
import { CChart } from '@coreui/react-chartjs'
// @ts-ignore
import { getStyle } from '@coreui/utils'
import { FinanceChartData } from '../types'

type Props = {
  data: FinanceChartData[]
}

export const FinanceChart: React.FC<Props> = ({ data }) => {
  const prepareChartData = (data: FinanceChartData[]) => {
    // Убираем время из даты и преобразуем значения в числа
    const processedData = data.map((item) => ({
      ...item,
      date: item.date.slice(0, 10), // Убираем время из даты
      value: item.value !== null ? parseFloat(item.value) : 0,
    }))

    const labels = [...new Set(processedData.map((item) => item.date))] // Получаем уникальные даты без времени

    const deposits = labels.map((label) => {
      const item = processedData.find(
        (d) => d.date === label && d.category === 'deposit',
      )
      return item ? item.value : 0
    })

    const withdrawals = labels.map((label) => {
      const item = processedData.find(
        (d) => d.date === label && d.category === 'withdrawal',
      )
      return item ? item.value : 0
    })

    return {
      labels: labels,
      datasets: [
        {
          label: 'Deposits',
          backgroundColor: 'rgba(220, 220, 220, 0.2)',
          borderColor: 'rgba(220, 220, 220, 1)',
          pointBackgroundColor: 'rgba(220, 220, 220, 1)',
          pointBorderColor: '#fff',
          data: deposits,
        },
        {
          label: 'Withdrawals',
          backgroundColor: 'rgba(151, 187, 205, 0.2)',
          borderColor: 'rgba(151, 187, 205, 1)',
          pointBackgroundColor: 'rgba(151, 187, 205, 1)',
          pointBorderColor: '#fff',
          data: withdrawals,
        },
      ],
    }
  }

  const chartData = useMemo(() => prepareChartData(data), [data])

  return (
    <CChart
      type="line"
      // @ts-ignore
      data={chartData}
      options={{
        aspectRatio: 1, // this would be a 1:1 aspect ratio
        plugins: {
          legend: {
            labels: {
              color: getStyle('--cui-body-color'),
            },
          },
        },
        scales: {
          x: {
            grid: {
              color: getStyle('--cui-border-color-translucent'),
            },
            ticks: {
              color: getStyle('--cui-body-color'),
            },
          },
          y: {
            grid: {
              color: getStyle('--cui-border-color-translucent'),
            },
            ticks: {
              color: getStyle('--cui-body-color'),
            },
          },
        },
      }}
    />
  )
}
